<template>
  <div>
    <el-dialog v-dialog-drag :title="title" :visible.sync="showDialog" width="600px" :destroy-on-close="true"
      :before-close="cancel">
      <el-form label-width="120px" ref="form" :model="form" :rules="rules">
        <el-form-item label="客户姓名" prop="contactName">
          <el-input v-model="form.contactName" auto-complete="off" placeholder="请输入客户姓名"></el-input>
        </el-form-item>
        <el-form-item label="电话号码" prop="phone">
          <el-input v-model="form.phone" auto-complete="off" placeholder="请输入电话号码"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input v-model="form.email" auto-complete="off" placeholder="请输入邮箱"></el-input>
        </el-form-item>
        <el-form-item label="地址" prop="address">
          <el-input v-model="form.address" auto-complete="off" placeholder="请输入具体地址"></el-input>
        </el-form-item>
        <el-form-item label="客户单位" prop="customerCompanyId">
          <el-select v-model="form.customerCompanyId" placeholder="请选择客户单位" filterable>
            <el-option v-for="item in companyOptions" :key="item.id" :label="item.companyName"
              :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="对应销售" prop="salesUuid">
          <el-select v-model="form.salesUuid" placeholder="请选择对应销售" filterable>
            <el-option v-for="item in salesOptions" :key="item.uuid" :label="item.name" :value="item.uuid"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="课题组" prop="researchGroupId" v-if="isGroupSelectable">
          <el-select v-model="form.researchGroupId" placeholder="请选择课题组" filterable clearable>
            <el-option v-for="item in groupOptions" :key="item.groupId" :label="item.principalInvestigator"
              :value="item.groupId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="研究方向" prop="researchDirection">
          <el-input v-model="form.researchDirection" auto-complete="off" placeholder="请输入目前研究方向"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="form.remark" type="textarea" :autosize="{ minRows: 3 }" maxlength="300" show-word-limit
            placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="cancel">取消</el-button>
        <el-button size="small" type="primary" class="title" @click="handle">保存</el-button>
      </div>
    </el-dialog>
    <loading :loading="loading" load-text="提交中"></loading>
  </div>
</template>

<script>

import {getAllCompanyName, getCustomerCompanyPage} from "@/api/dilivery/customer/company";
import {checkMail} from "@/utils/rules";
import { getPersonByType, getPersonById } from "@/api/dilivery/customer/person";
import {getResearchGroupByCompanyId} from "@/api/dilivery/customer/researchGroup";
import {addUser, editUser} from "@/api/dilivery/customer/user";
import {getDataInLocalStorage} from "@/utils/localStorage";
import Loading from "@/components/loading/Loading.vue";

export default {
  name: "AddCustomerUser",
  props:['showDialog','selectType','selectDetail'],
  components: { Loading },
  data(){
    return{
      loading:false,
      userData:{},
      companyOptions: [],
      groupOptions: [],
      salesOptions: [],
      title:'',
      role:'',
      isGroupSelectable: false,
      form:{
        researchGroupId: "",
        customerCompanyId: "",
        salesUuid: "",
        contactName: '',
        phone: '',
        email: '',
        address: '',
        researchDirection: '',
        title: '',
        administrativePosition: '',
        responsibilityAttribute: '',
        remark: ''
      },
      rules: {
        salesUuid: [
          {required: true, message: '请输入销售员名称', trigger: 'change'}
        ],
        customerCompanyId: [
          {required: true, message: '请选择客户单位', trigger: 'change'}
        ],
        researchGroupId: [
          {message: '请选择课题组', trigger: 'change'}
        ],
        contactName: [
          {required: true, message: '请输入联系人姓名', trigger: 'change'}
        ],
        phone: [
          {required: true, message: '请输入联系方式', trigger: 'change'}
        ],
        email: [
          {required: true, message: '请输入邮箱', trigger: 'change'},
          {validator: checkMail, trigger: 'change'}
        ],
        address: [
          {message: '请输入地址', trigger: 'change'}
        ],
        researchDirection: [
          {message: '请输入研究方向', trigger: 'change'}
        ],
        title: [
          {message: '请输入职称', trigger: 'change'}
        ],
        administrativePosition: [
          {message: '请输入行政职位', trigger: 'change'}
        ],
        responsibilityAttribute: [
          {message: '请输入职责属性', trigger: 'change'}
        ],
        remark: [
          {message: '请输入备注', trigger: 'change'}
        ],
      },
    }
  },
  created() {
    this.userData = JSON.parse(getDataInLocalStorage('user'))
    this.role = getDataInLocalStorage('role')
    this.getSalesOptions();
    this.getCompanyOptions();
  },
  watch:{
    selectType:{
      handler(newVal){
        if (newVal){
          if(newVal.type==='edit'){
            this.title='编辑客户联系人信息'
          }else {
            this.title='添加客户联系人信息'
          }
        }
      },
      immediate:true
    },
    selectDetail: {
      async handler(newVal) {
        if (newVal && Object.keys(newVal)) {
          this.form.id = newVal.id
          if (newVal['sales']) {
            this.salesOptions.push(newVal['sales'])
            this.form.salesUuid = newVal['sales'].uuid
          }
          if (newVal.customerCompanyId) {
            this.companyOptions.push(newVal['customerCompany'])
            this.form.customerCompanyId = newVal.customerCompanyId
            this.isGroupSelectable = true
            await this.getGroupOptions(newVal.customerCompanyId)
            this.form.researchGroupId = newVal.researchGroupId
          }
          this.form.contactName = newVal.contactName
          this.form.phone = newVal.phone
          this.form.email = newVal.email
          this.form.address = newVal.address
          this.form.researchDirection = newVal.researchDirection
          this.form.title = newVal.title
          this.form.administrativePosition = newVal.administrativePosition
          this.form.responsibilityAttribute = newVal.responsibilityAttribute
          this.form.remark = newVal.remark
        }
      },
      immediate: true
    },
    'form.customerCompanyId': {
      handler(newVal, oldVal) {
        if (newVal !== '') {
          this.isGroupSelectable = true
          this.getGroupOptions(newVal);
          if (newVal !== oldVal && oldVal) {
            this.form.researchGroupId = ''
          }
        } else {
          // 如果清空了客户单位，清空课题组
          this.groupOptions = [];
          this.isGroupSelectable = false
        }
      },
      immediate: true
    },
  },
  methods: {
    getSalesOptions() {
      try {
        if (['ADMIN', 'MANAGER', 'SALES_ASSI_MANAGER', 'SALES_ASSI'].includes(this.role)) {
          getPersonByType('SALES', {}).then(res => {
            if (res.code === 200) {
              this.salesOptions = res.data;
              this.checkUser()
            }
          }).catch(err => { })
        } else {
          getPersonById(this.userData['personUuids'][0], {}).then(res => {
            if (res.code === 200) {
              this.salesOptions = res.data;
              this.checkUser();
            }
          }).catch(err => { })
        }
      } catch (error) {
        console.log(error);
      }
    },
    checkUser() {
      if (this.salesOptions.some(item => item.uuid === this.userData['personUuids'][0])) {
        if (this.form.salesUuid === '') {
          this.form.salesUuid = this.userData['personUuids'][0];
        }
      }
    },
    getCompanyOptions() {
      try {
        getAllCompanyName().then(res => {
          if (res.code === 200) {
            this.companyOptions = res.data;
          }
        })
      } catch (error) {
        console.log(error);
      }
    },
    getGroupOptions(newV) {
      try {
        getResearchGroupByCompanyId(newV).then(res => {
          if (res.code === 200) {
            this.groupOptions = res.data;
          }
        })
      } catch (error) {
        console.log(error);
      }
    },
    cancel() {
      this.$emit('submit', 'cancel')
    },
    handle() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true
          if (this.selectType.type === 'add') {
            addUser(this.form).then(res => {
              if (res.code === 200) {
                this.loading = false
                this.$emit('submit', 'confirm')
                this.$messageUi.success('添加成功')
              }
            }).catch(err => {
              this.loading = false
            })
          } else {
            editUser(this.form).then(res => {
              if (res.code === 200) {
                this.loading = false
                this.$emit('submit', 'confirm')
                this.$messageUi.success('修改成功')
              }
            }).catch(err => {
              this.loading = false
            })
          }
        } else {
          this.$nextTick(() => {
            let err = document.getElementsByClassName('is-error')
            if (err.length) {
              err[0].scrollIntoView({
                block: 'center',
                behavior: 'smooth',
              })
            }
          })
          this.$messageUi.error('填写参数不规范，请检查')
        }
      })

    }
  }
}
</script>

<style scoped></style>